export default "__VITE_ASSET__ab4aeba5__"